import request from '@/utils/request'

// 精品课程表

let CourseApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.course/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.course/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.course/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._get('/shop/study.course/edit', data, errorback);
    },

    /*编辑*/
    save(data, errorback) {
        return request._post('/shop/study.course/edit', data, errorback);
    },

    /*状态*/
    status(data, errorback) {
      return request._post('/shop/study.course/status', data, errorback);
    },

    /*批量*/
    batch(data, errorback) {
        return request._post('/shop/study.course/batch', data, errorback);
    },
}

export default CourseApi;



// WEBPACK FOOTER //
// ./src/api/study/course.js